<script setup>
import { useStore } from "vuex";
import { computed } from "vue";
import ArtworkLoadedMessage from "../artworkComponents/ArtworkLoadedMessage.vue";
import ArtworkLoadingMessage from "../artworkComponents/ArtworkLoadingMessage.vue";
import UploadAction from "./UploadAction.vue";
import { trackRemoveArtworkClick, trackCancelArtworkUploadClick } from "../utils/tracker";

const store = useStore();
const isUploadComplete = computed(() => store.getters["loading/isUploadComplete"]);
const artwork = computed(() => store.getters["checkout/artwork"]);

const deleteArtwork = async () => {
  await store.dispatch("checkout/removePlacement");
  trackRemoveArtworkClick();
  window.location.reload();
};

const cancelArtwork = async () => {
  trackCancelArtworkUploadClick(artwork.value?.id);
  window.location.reload();
};
</script>

<template>
  <div class="upload-header">
    <div class="upload-header__messages">
      <ArtworkLoadingMessage v-if="!isUploadComplete" />

      <ArtworkLoadedMessage v-else landing />
    </div>

    <div class="upload-header__actions">
      <UploadAction v-if="!isUploadComplete" type="cancel" @action="cancelArtwork" />

      <UploadAction v-else type="delete" @action="deleteArtwork" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
